<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>{{idvTitle}} details</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-container *ngFor="let person of personFormArray.controls; index as i">
      <mat-card appearance="outlined" [formGroup]="person">
        <mat-card-content>
          <div class="row">
            <div class="col-sm-2">
              <h4 *ngIf="!person.value.nonApplicant">{{idvTitle}} {{i + 1}}</h4>
              <h4 *ngIf="person.value.nonApplicant">Non-Applicant Spouse</h4>
              <!-- <button *ngIf="i !== 0" mat-raised-button color="warn" class="button-absolute-right" type="button" (click)="removePerson(i)">Remove person</button> -->
            </div>
            <div class="col-sm-2" *ngIf="isHomeLoan && !person.value.nonApplicant">
              <mat-form-field appearance="outline">
                <mat-label>Applicant type</mat-label>
                <mat-select placeholder="Applicant type" formControlName="borrowerGuarantor"
                            (selectionChange)="checkValidators()" [tabIndex]="(i * 100) + 1">
                  <mat-option *ngFor="let type of borrowerGuarantorTypes" [value]="type.id">{{type.text}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-2">
              <mat-error *ngIf="personFormArray?.errors?.invalidBorrowerGuarantorTypes">
                <small>At least 1 borrower is required.<br/><br/></small>
              </mat-error>
            </div>
            <div class="col-sm-6 text-end" *ngIf="personFormArray.length > 1 && !person.value.nonApplicant">
              <button type="button" mat-icon-button
                      (click)="personFormArray.removeAt(i); broadcastPersonList(i); clearPrivacyConsent()" color="warn"
                      *ngIf="!first">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>First name</mat-label>
                <input matInput placeholder="First name" formControlName="firstName" tabindex="{{(i * 100) + 2}}">
                <mat-error>
                  <app-validation-partial
                    [formGroup]="person"
                    [fieldName]="'firstName'"
                  ></app-validation-partial>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>Middle name</mat-label>
                <input matInput placeholder="Middle name" formControlName="middleName" tabindex="{{(i * 100) + 3}}">
                <mat-error>
                  <app-validation-partial
                    [formGroup]="person"
                    [fieldName]="'middleName'"
                  ></app-validation-partial>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>Last name</mat-label>
                <input matInput placeholder="Last name" formControlName="lastName" tabindex="{{(i * 100) + 4}}">
                <mat-error>
                  <app-validation-partial
                    [formGroup]="person"
                    [fieldName]="'lastName'"
                  ></app-validation-partial>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row" *ngIf="!person.value.nonApplicant">
            <div [ngClass]="!isHomeLoan ? 'col-3' : 'col-4'">
              <fmc-date-text
                [hidden]="isFurtherAdvance"
                [required]="!isFurtherAdvance"
                [maxAgeRestriction]="true"
                [minAgeRestriction]="true"
                [tabindex]="(i * 100) + 5"
                [parentFormGroup]="person"
                [controlName]="'dateOfBirth'"
                [placeholderText]="'Date of birth'"
                [centralisedValidation]="!isFurtherAdvance"
              ></fmc-date-text>
            </div>
            <div class="col-3" *ngIf="!isHomeLoan">
              <mat-form-field appearance="outline">
                <mat-label>Licence state</mat-label>
                <mat-select placeholder="Licence state" formControlName="driversLicenceState"
                            (selectionChange)="checkIdValidation($event.value, person)" tabindex="{{(i * 100) + 7}}">
                  <mat-option *ngFor="let state of australianStateTypes"
                              value="{{state?.ext?.Slug}}">{{state.text}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div [ngClass]="!isHomeLoan ? 'col-3' : 'col-4'" *ngIf="!isHomeLoan || (isHomeLoan && !isFurtherAdvance)">
              <mat-form-field appearance="outline">
                <mat-label>Driver's licence number</mat-label>
                <input matInput placeholder="Driver's Licence Number" (change)="checkLicenceValidation(person)"
                       formControlName="driversLicence" tabindex="{{(i * 100) + 6}}">
                <mat-error>
                  <app-validation-partial
                    [formGroup]="person"
                    [fieldName]="'driversLicence'"
                  ></app-validation-partial>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-3" *ngIf="!isHomeLoan && person?.get('driversLicenceState')?.value"
                 [hidden]="(person?.get('driversLicenceState')?.value === 'au-ql' && !showQldFields) || (person?.get('driversLicenceState')?.value === 'au-vi' && !showVicFields)">
              <mat-form-field appearance="outline">
                <mat-label>Card number</mat-label>
                <input matInput placeholder="Card number" formControlName="driversLicenceCardNumber"
                       tabindex="{{(i * 100) + 8}}">
                <mat-error>
                  <app-validation-partial
                    [formGroup]="person"
                    [fieldName]="'driversLicenceCardNumber'"
                  ></app-validation-partial>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row" *ngIf="person.value.nonApplicant">
            <!-- Email -->
            <div class="col-sm-4">
              <fmc-sensis-email
                [tabindex]="(i * 100) + 11"
                [parentFormGroup]="person"
                [controlName]="'email'"
                [placeholderText]="'Email address'"
                [notRequired]="true"
                [centralisedValidation]="true"
              ></fmc-sensis-email>
              <mat-error
                *ngIf="personFormArray?.errors?.duplicateEmails && personFormArray.errors.duplicateEmails === person.value.email">
                <small>Please ensure all borrower emails are unique.<br/><br/></small>
              </mat-error>
            </div>

            <ng-container *ngIf="person && person.controls.phones && person.controls.phones.controls">
              <!-- List of phones -->
              <ng-container *ngFor="let phone of person.controls.phones.controls; index as k">
                <div class="col-sm-4" [formGroup]="phone">
                  <mat-form-field appearance="outline">
                    <mat-label>Phone type</mat-label>
                    <mat-select placeholder="Phone type" formControlName="phoneType" [tabIndex]="(i * 100) + 15">
                      <mat-option *ngFor="let type of phoneTypes" [value]="type.id">
                        {{type.text}}
                      </mat-option>
                    </mat-select>
                    <mat-error>
                      <app-validation-partial
                        [formGroup]="phone"
                        [fieldName]="'phoneType'"
                      ></app-validation-partial>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-4">
                  <fmc-sensis-mobile
                    [tabindex]="(i * 100) + 16"
                    [parentFormGroup]="phone"
                    [controlName]="'phoneNumber'"
                    [acceptedPhoneTypes]="acceptedPhoneTypes[phone.value.phoneType] || []"
                    [rejectedPhoneTypes]="rejectedPhoneTypes[phone.value.phoneType] || []"
                    [placeholderText]="'Phone number'"
                  ></fmc-sensis-mobile>
                </div>
                <div class="col-sm-4">
                  <mat-error class="mt-4"
                    *ngIf="personFormArray?.errors?.duplicateMobiles && personFormArray.errors.duplicateMobiles === phone.value.phoneNumber">
                    <small>Borrowers cannot share the same mobile numbers. <br/><br/></small>
                  </mat-error>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <div class="row" *ngIf="!person.value.nonApplicant">
            <div [ngClass]="(isHomeLoan && isFurtherAdvance) ? 'col-3' : 'col-4'">
              <mat-form-field appearance="outline">
                <mat-label>Select marital status</mat-label>
                <mat-select placeholder="Select marital status" formControlName="maritalStatus"
                            [tabIndex]="(i * 100) + 7">
                  <mat-option *ngFor="let status of maritalStatusTypes" [value]="status.id">{{status.text}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div [ngClass]="(isHomeLoan && isFurtherAdvance) ? 'col-3' : 'col-4'">
              <mat-form-field appearance="outline">
                <mat-label>Dependents under 11</mat-label>
                <input matInput placeholder="Dependents under 11" formControlName="dependentsUnder11" type="number"
                       tabindex="{{(i * 100) + 8}}">
                <mat-error>
                  <app-validation-partial
                    [formGroup]="person"
                    [fieldName]="'dependentsUnder11'"
                  ></app-validation-partial>
                </mat-error>
              </mat-form-field>
            </div>
            <div [ngClass]="(isHomeLoan && isFurtherAdvance) ? 'col-3' : 'col-4'">
              <mat-form-field appearance="outline">
                <mat-label>Dependents 11 and over</mat-label>
                <input matInput placeholder="Dependents 11 and over" formControlName="dependentsOver11" type="number"
                       tabindex="{{(i * 100) + 9}}">
                <mat-error>
                  <app-validation-partial
                    [formGroup]="person"
                    [fieldName]="'dependentsOver11'"
                  ></app-validation-partial>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-3" *ngIf="isHomeLoan && isFurtherAdvance">
              <mat-form-field appearance="outline">
                <mat-label>Driver's licence number</mat-label>
                <input matInput placeholder="Driver's Licence Number" (change)="checkLicenceValidation(person)"
                       formControlName="driversLicence" tabindex="{{(i * 100) + 6}}">
                <mat-error>
                  <app-validation-partial
                    [formGroup]="person"
                    [fieldName]="'driversLicence'"
                  ></app-validation-partial>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Addresses and Contact Details -->
          <div class="row">
            <!-- Addresses -->
            <div class="col-sm-8">
              <!-- Home Address -->
              <div class="row" *ngIf="!person.value.nonApplicant">
                <div *ngIf="i > 0" class="col-sm-12">
                  <mat-checkbox formControlName="residentialAddressSameAsBorrower1"
                                (change)="addressAsBorrower1($event, person, 'residentialAddressSameAsBorrower1')">
                    Residential Address same as Borrower 1
                  </mat-checkbox>
                </div>
                <div class="col-sm-12">
                  <ng-container
                    *ngIf="i == 0 || i > 0 && person.controls.residentialAddressSameAsBorrower1.value === false">
                    <app-address-suggestions
                      [formGroup]="person"
                      [control]="'homeAddress'"
                    ></app-address-suggestions>
                  </ng-container>
                  <fmc-address-search
                    [tabindex]="(i * 100) + 10"
                    [mode]="'external'"
                    [parentFormGroup]="person"
                    [controlName]="'homeAddress'"
                    [placeholderText]="'Home address'"
                    [allowPOBox]="false"
                    [required]="true"
                  ></fmc-address-search>
                </div>
              </div>
              <div class="row" *ngIf="!person.value.nonApplicant">
                <div class="col-6">
                  <mat-form-field appearance="outline">
                    <mat-label>Residency type</mat-label>
                    <mat-select placeholder="Residency type" formControlName="residencyType" [tabIndex]="(i * 100) + 12">
                      <mat-option *ngFor="let type of residencyTypes" [value]="type.id">
                        {{type.text}}
                      </mat-option>
                    </mat-select>
                    <mat-error>
                      <app-validation-partial
                        [formGroup]="person"
                        [fieldName]="'residencyType'"
                      ></app-validation-partial>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-3">
                  <mat-form-field appearance="outline">
                    <mat-label>Time at address (years)</mat-label>
                    <input matInput placeholder="Time at address (years)" min="0" type="number"
                           formControlName="stayAtHomeYears" tabindex="{{(i * 100) + 13}}">
                    <mat-error>
                      <app-validation-partial
                        [formGroup]="person"
                        [fieldName]="'stayAtHomeYears'"
                      ></app-validation-partial>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-3">
                  <mat-form-field appearance="outline">
                    <mat-label>Time at address (months)</mat-label>
                    <input matInput placeholder="Time at address (months)" min="0" type="number" max="11"
                           formControlName="stayAtHomeMonths" tabindex="{{(i * 100) + 14}}">
                    <mat-error>Please input a number between 0 and 11</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <!-- Previous Address -->
              <ng-container *ngIf="person.get('previousAddresses')">
                <ng-container
                  *ngFor="let prevAddr of person.get('previousAddresses').controls; index as prevAddressIndex">
                  <div class="row" [formGroup]="prevAddr">
                    <div *ngIf="i > 0 && bwr1PreviousAddressLength > prevAddressIndex" class="col-sm-12">
                      <mat-checkbox formControlName="previousAddressSameAsBorrower1"
                                    (change)="addressAsBorrower1($event, person, 'previousAddressSameAsBorrower1', prevAddr)">
                        Previous Address same as Borrower 1
                      </mat-checkbox>
                    </div>
                    <div class="col-sm-12">
                      <app-address-suggestions
                        [formGroup]="prevAddr"
                        [control]="'previousAddress'"
                      ></app-address-suggestions>
                      <fmc-address-search
                        [mode]="'external'"
                        [parentFormGroup]="prevAddr"
                        [controlName]="'previousAddress'"
                        [placeholderText]="'Previous address'"
                        [allowPOBox]="false"
                      ></fmc-address-search>
                    </div>
                  </div>
                  <div class="row" [formGroup]="prevAddr">
                    <div class="col-6">
                      <mat-form-field appearance="outline">
                        <mat-label>Previous residency type</mat-label>
                        <mat-select placeholder="Previous residency type" formControlName="prevResidencyType">
                          <mat-option *ngFor="let type of residencyTypes" [value]="type.id">
                            {{type.text}}
                          </mat-option>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="prevAddr"
                            [fieldName]="'prevResidencyType'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                      <mat-form-field appearance="outline">
                        <mat-label>Time at address (years)</mat-label>
                        <input matInput placeholder="Time at address (years)" min="0" type="number"
                               formControlName="stayAtPrevYears">
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="prevAddr"
                            [fieldName]="'stayAtPrevYears'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                      <mat-form-field appearance="outline">
                        <mat-label>Time at address (months)</mat-label>
                        <input matInput placeholder="Time at address (months)" min="0" type="number" max="11"
                               formControlName="stayAtPrevMonths">
                        <mat-error>Please input a number between 0-11</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </ng-container>
              </ng-container>


              <!-- Postal Address -->
              <div class="row" *ngIf="!person.value.nonApplicant">
                <div class="col-sm-8" *ngIf="!person.value.postalAddressAsHome">
                  <app-address-suggestions
                    [formGroup]="person"
                    [control]="'postalAddress'"
                  ></app-address-suggestions>
                  <fmc-address-search
                    [mode]="'external'"
                    [parentFormGroup]="person"
                    [controlName]="'postalAddress'"
                    [placeholderText]="'Postal address'"
                  ></fmc-address-search>
                </div>
                <div class="col-sm-12">
                  <mat-checkbox formControlName="postalAddressAsHome" tabindex="-1">
                    Postal address same as home
                  </mat-checkbox>
                </div>
              </div>

              <!-- Post-settlement Address -->
              <div class="row" *ngIf="!person.value.nonApplicant && !person?.value?.postSettlementAddressNotAvailable">
                <div class="col-sm-8" *ngIf="!person.value.postSettlementAddressAsHome">
                  <app-address-suggestions
                    [formGroup]="person"
                    [control]="'postSettlementAddress'"
                  ></app-address-suggestions>
                  <fmc-address-search
                    [mode]="'external'"
                    [parentFormGroup]="person"
                    [controlName]="'postSettlementAddress'"
                    [placeholderText]="'Address after settlement'"
                    [required]="true"
                  ></fmc-address-search>
                </div>
              </div>
              <div class="row" *ngIf="!person?.value?.postSettlementAddressNotAvailable && !person.value.nonApplicant">
                <div class="col-sm-12">
                  <mat-checkbox formControlName="postSettlementAddressAsHome" tabindex="-1">
                    Address after settlement same as home
                  </mat-checkbox>
                </div>
              </div>
              <div class="row"
                   *ngIf="isHomeLoan && person.get('postSettlementAddressNotAvailable') && !person.value.postSettlementAddressAsHome">
                <div class="col-sm-12">
                  <mat-checkbox formControlName="postSettlementAddressNotAvailable" tabindex="-1"
                                (change)="updatePostSettlementValidation($event, person)">
                    I haven't found a property yet (Preliminary Approval)
                  </mat-checkbox>
                </div>
              </div>

              <!-- Citizenship -->
              <div class="row" *ngIf="!person.value.nonApplicant">
                <div class="col-sm-12">
                  <mat-checkbox formControlName="auCitizen" *ngIf="person.value.firstName || person.value.lastName"
                                tabindex="-1">
                    <strong>{{person.value.firstName}} {{person.value.lastName}} </strong>is not an Australian citizen & does not have a permanent resident visa
                  </mat-checkbox>
                  <mat-checkbox formControlName="auCitizen" *ngIf="!person.value.firstName && !person.value.lastName"
                                tabindex="-1">
                    <strong>{{idvTitle}} {{i + 1}} </strong>is not an Australian citizen & does not have a permanent resident visa
                  </mat-checkbox>
                </div>
              </div>

              <!-- NCCP Question -->
              <div class="row" *ngIf="isHomeLoan && !person.value.nonApplicant">
                <div class="col-sm-12">
                  <mat-checkbox formControlName="nccpCovered" [tabIndex]="(i * 100) + 17">
                    Tick if applicant has declared any foreseeable changes
                  </mat-checkbox>
                </div>
              </div>
              <div class="row" *ngIf="isHomeLoan && person.value.nccpCovered">
                <div class="col-sm-12">
                  <mat-form-field appearance="outline">
                    <mat-label>If yes, provide details (character limit 1000)</mat-label>
                    <textarea
                      matInput
                      placeholder="If yes, provide details (character limit 1000)"
                      formControlName="nccpNotes"
                      rows="5"
                      [tabIndex]="(i * 100) + 18"
                    ></textarea>
                    <mat-error>
                      <app-validation-partial
                        [formGroup]="person"
                        [fieldName]="'nccpNotes'"
                      ></app-validation-partial>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Contact Details -->
            <div class="col-sm-4" *ngIf="!person.value.nonApplicant">
              <!-- Email -->
              <div class="row">
                <div *ngIf="i > 0" class="col-sm-12 mb-2">&nbsp;</div>
                <div class="col-sm-12">
                  <fmc-sensis-email
                    [tabindex]="(i * 100) + 11"
                    [parentFormGroup]="person"
                    [controlName]="'email'"
                    [placeholderText]="'Email address'"
                    [centralisedValidation]="true"
                  ></fmc-sensis-email>
                  <mat-error
                    *ngIf="personFormArray?.errors?.duplicateEmails && personFormArray.errors.duplicateEmails === person.value.email">
                    <small>Please ensure all borrower emails are unique.<br/><br/></small>
                  </mat-error>
                </div>
              </div>

              <!-- List of phones -->
              <ng-container *ngIf="person.controls.phones">
                <div *ngFor="let phone of person.controls.phones.controls; index as k">
                  <div class="row mb-3" [formGroup]="phone">
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Phone type</mat-label>
                        <mat-select placeholder="Phone type" formControlName="phoneType" [tabIndex]="(i * 100) + 15">
                          <mat-option *ngFor="let type of phoneTypes" [value]="type.id">
                            {{type.text}}
                          </mat-option>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="phone"
                            [fieldName]="'phoneType'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                      <fmc-sensis-mobile
                        [tabindex]="(i * 100) + 16"
                        [parentFormGroup]="phone"
                        [controlName]="'phoneNumber'"
                        [acceptedPhoneTypes]="acceptedPhoneTypes[phone.value.phoneType] || []"
                        [rejectedPhoneTypes]="rejectedPhoneTypes[phone.value.phoneType] || []"
                        [placeholderText]="'Phone number'"
                      ></fmc-sensis-mobile>

                    </div>
                    <div class="col-sm-2">
                      <button type="button" mat-icon-button (click)="deletePhone(i, k)" color="warn" *ngIf="k !== 0">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <mat-error
                        class="mt-4"
                        *ngIf="personFormArray?.errors?.duplicateMobiles && personFormArray.errors.duplicateMobiles === phone.value.phoneNumber">
                        <small>Borrowers cannot share the same mobile numbers. <br/><br/></small>
                      </mat-error>
                    </div>
                  </div>
                  <div class="row" *ngIf="k === person.controls.phones.controls.length - 1">
                    <div class="col-sm-8">
                      <mat-error *ngIf="person.controls.phones.errors?.noSameValues">
                        <small>Borrower's Phone numbers must be unique <br/><br/></small>
                      </mat-error>
                    </div>
                    <div class="col-sm-4">
                      <button mat-raised-button type="button" (click)="addPhone(i)" [tabindex]="(i * 100) + 18" class="fmc-button-primary">Add
                        Phone
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- ABN for sole-trader and partnership -->
          <div class="row" *ngIf="!person.value.nonApplicant && person.get('showPersonABN').value">
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>Business name</mat-label>
                <input matInput placeholder="Business name" formControlName="orgName">
                <mat-error>
                  <app-validation-partial
                    [formGroup]="person"
                    [fieldName]="'orgName'"
                  ></app-validation-partial>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>Trading name</mat-label>
                <input matInput placeholder="Trading name" formControlName="orgTrading">
                <mat-error>
                  <app-validation-partial
                    [formGroup]="person"
                    [fieldName]="'orgTrading'"
                  ></app-validation-partial>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <input matInput placeholder="ABN" formControlName="orgABN">
                <mat-error>
                  <app-validation-partial
                    [formGroup]="person"
                    [fieldName]="'orgABN'"
                  ></app-validation-partial>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Relationships -->
          <mat-card appearance="outlined"
                    *ngIf="!appHasNonApplicant && (person?.controls?.relationships?.length || person?.controls?.companyRelationships?.length)">
            <mat-card-header>
              <mat-card-title>Relationships</mat-card-title>
              <mat-card-subtitle *ngIf="person?.controls?.companyRelationships?.errors?.duplicateRelationships">
                <span class="text-danger">Please ensure all relationships are unique</span>
              </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <ng-container *ngIf="person.controls.relationships.length > 0">
                <div *ngFor="let relationship of person.controls.relationships.controls; index as j">
                  <div class="row" [formGroup]="relationship">
                    <div class="col-sm-1">
                      <mat-form-field appearance="outline">
                        <mat-label>I am</mat-label>
                        <input matInput value="I am" readonly tabindex="-1">
                      </mat-form-field>
                    </div>
                    <div class="col-sm-7">
                      <mat-form-field appearance="outline">
                        <mat-label>Select relationship with</mat-label>
                        <mat-select placeholder="Select relationship with" formControlName="type"
                                    [tabIndex]="(i * 100) + 19">
                          <ng-container *ngFor="let relationshipType of relationshipTypes">
                            <mat-option [value]="relationshipType.slug">{{relationshipType.msg}}</mat-option>
                          </ng-container>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="person"
                            [fieldName]="'type'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline" *ngIf="relationship.value.type === 'couple-with-applicant'">
                        <mat-label>Select borrower</mat-label>
                        <mat-select placeholder="Select Borrower" formControlName="to"
                                    (selectionChange)="handleLinkedPersons(relationship.value.from, $event.value)">
                          <ng-container *ngFor="let person of personFormArray.controls; index as personCnt">
                            <mat-option [disabled]="hasExistingRelationship(i + 1, personCnt + 1)"
                                        *ngIf="personCnt !== i && !person.getRawValue().nonApplicant" [value]="personCnt + 1">
                              <ng-container *ngIf="!person.getRawValue().firstName && !person.getRawValue().lastName; else withName">
                                Person {{personCnt + 1}}</ng-container>
                            </mat-option>
                            <ng-template #withName>
                              {{person.getRawValue().firstName}} {{person.getRawValue().lastName}}
                            </ng-template>
                          </ng-container>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="person"
                            [fieldName]="'type'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- Company Relationships -->
              <ng-container
                *ngIf="person.controls.companyRelationships && person.controls.companyRelationships.length > 0">
                <!-- <ng-container> -->
                <div *ngFor="let relationship of person.controls.companyRelationships.controls; index as j">
                  <div class="row" [formGroup]="relationship">
                    <div class="col-sm-2">
                      <mat-form-field appearance="outline">
                        <mat-label>I am related to</mat-label>
                        <input matInput value="I am related to" readonly tabindex="-1">
                      </mat-form-field>
                    </div>
                    <div class="col-sm-5">
                      <mat-form-field appearance="outline">
                        <mat-select placeholder="Select Company" formControlName="to">
                          <mat-label>Select company</mat-label>
                          <ng-container *ngFor="let trust of trustList.value; index as trustCnt">
                            <mat-option
                              value="trust-{{trustCnt}}">{{trust.trustName || 'Trust ' + (trustCnt + 1)}}</mat-option>
                          </ng-container>
                          <ng-container *ngFor="let company of companyList.value; index as companyCnt">
                            <mat-option
                              value="company-{{companyCnt}}">{{company.companyName || 'Company ' + (companyCnt + 1)}}</mat-option>
                          </ng-container>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="person"
                            [fieldName]="'type'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Select relationship with</mat-label>
                        <mat-select placeholder="Select relationship with" formControlName="type"
                                    [tabIndex]="(i * 100) + 19">
                          <mat-option
                            *ngIf="borrowerType === 'company' || borrowerType !== 'trust-with-individual'"
                            [disabled]="companyList.length === 0" value="director">as a DIRECTOR
                          </mat-option>
                          <mat-option
                            *ngIf="borrowerType !== 'company'"
                            [disabled]="trustList.length === 0" value="trustee">as a TRUSTEE
                          </mat-option>
                        </mat-select>
                        <mat-error>
                          <app-validation-partial
                            [formGroup]="person"
                            [fieldName]="'type'"
                          ></app-validation-partial>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-1">
                      <button *ngIf="person.controls.companyRelationships.length > 1" type="button" mat-icon-button
                              (click)="person.controls.companyRelationships.removeAt(j)" color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- </ng-container> -->
              </ng-container>
              <div class="row" *ngIf="!person.value.nonApplicant">
                <div class="col-sm-12 text-end" *ngIf="companyList.length > 0 || trustList.length > 0">
                  <button mat-raised-button color="primary" type="button" class="fmc-button-primary"
                          (click)="addRelationshipToCompany(i, person.controls.companyRelationships)">Add Relationship
                  </button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Credit Reporting -->
          <mat-card appearance="outlined" *ngIf="isHomeLoan && hasCrumbsPermission">
            <mat-card-content>
              <div class="col-sm-6">
                <mat-form-field appearance="outline">
                  <mat-label>Credit report enquiry ID</mat-label>
                  <input matInput placeholder="Credit report enquiry ID" formControlName="creditReportEnquiryId">
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-card-content>
      </mat-card>
    </ng-container>
    <div class="row add-person" *ngIf="personFormArray.controls.length < borrowerCount">
      <div class="col-sm-12 text-end">
        <button mat-raised-button color="primary" type="button" (click)="addNewIndividual()" class="fmc-button-primary">Add person</button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-end">
        <app-further-advance-confirmation
          *ngIf="isFurtherAdvance"
          [formGroup]="formGroup"
          [widgetName]="'app-personal-details'"
        ></app-further-advance-confirmation>
      </div>
    </div>
  </mat-card-content>
</mat-card>
